import React, { useState } from 'react';

import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const CheckboxSelect = ({ options, values, onChange }) => {
  const [state, setState] = useState(new Map(options.map((o, i) => {
    return [o, values[i]]
  })));

  const handleChange = option => {
    const updated = new Map(state);
    updated.set(option, !updated.get(option));

    setState(updated);
    onChange(updated)
  }

  if (!state) return <></>;

  return (
    <FormGroup row>
      {
        options.map((opt, i) => {
          return (
            <FormControlLabel key={i}
              control={<Checkbox checked={state.get(opt)} onChange={() => handleChange(opt)}  />}
              label={opt}
            />);
        })
      }
    </FormGroup>
  );
}

export default CheckboxSelect;